import { createContext } from 'react';

/**
 * Default challenge runner used when no MfaProvider is mounted (e.g. isolated
 * renders and unit tests): simply runs the operation with no TOTP code and
 * returns its response, so nothing is gated at the UI. In the app the
 * MfaProvider replaces this with the real 428 -> prompt -> retry runner.
 * @param {(mfaCode?: string) => Promise<Response>} operation
 * @param {{ onMfaRequired?: Function }} [options]
 * @returns {Promise<Response>}
 */
const passthroughRun = (operation) => operation();

// Context value is the `run` function from useMfaVerification (or the passthrough).
const MfaContext = createContext(passthroughRun);

export default MfaContext;
